export const filterOutById = (id: string) => (element: { id: string }) =>
  id !== element.id

export const haveSomeValuesIncluded = <T>(listA: T[], listB: T[]) =>
  listA.some((value: T) => listB.includes(value))

export const filterListOut = <T>(
  list: T[],
  filterList: Array<(modules: T) => boolean>
) => {
  return list.filter((m) => filterList.every((fn) => fn(m)))
}
